<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Colors</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Colors</h5>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <p class="text-primary">.text-primary</p>
                  <p class="text-secondary">.text-secondary</p>
                  <p class="text-success">.text-success</p>
                  <p class="text-danger">.text-danger</p>
                  <p class="text-warning">.text-warning</p>
                  <p class="text-info">.text-info</p>
                  <p class="text-light bg-dark">.text-light</p>
                  <p class="text-dark">.text-dark</p>
                  <p class="text-body">.text-body</p>
                  <p class="text-muted">.text-muted</p>
                  <p class="text-white bg-dark">.text-white</p>
                  <p class="text-black-50">.text-black-50</p>
                  <p class="text-white-50 bg-dark">.text-white-50</p>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;p class=&quot;text-primary&quot;&gt;.text-primary&lt;/p&gt;
  &lt;p class=&quot;text-secondary&quot;&gt;.text-secondary&lt;/p&gt;
  &lt;p class=&quot;text-success&quot;&gt;.text-success&lt;/p&gt;
  &lt;p class=&quot;text-danger&quot;&gt;.text-danger&lt;/p&gt;
  &lt;p class=&quot;text-warning&quot;&gt;.text-warning&lt;/p&gt;
  &lt;p class=&quot;text-info&quot;&gt;.text-info&lt;/p&gt;
  &lt;p class=&quot;text-light bg-dark&quot;&gt;.text-light&lt;/p&gt;
  &lt;p class=&quot;text-dark&quot;&gt;.text-dark&lt;/p&gt;
  &lt;p class=&quot;text-body&quot;&gt;.text-body&lt;/p&gt;
  &lt;p class=&quot;text-muted&quot;&gt;.text-muted&lt;/p&gt;
  &lt;p class=&quot;text-white bg-dark&quot;&gt;.text-white&lt;/p&gt;
  &lt;p class=&quot;text-black-50&quot;&gt;.text-black-50&lt;/p&gt;
  &lt;p class=&quot;text-white-50 bg-dark&quot;&gt;.text-white-50&lt;/p&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">

              <p>Contextual text classes also work well on anchors with the provided hover and focus states.
                <strong>Note
                  that the <code class="text-danger">.text-white</code> and <code class="text-danger">.text-muted</code>
                  class has no additional link styling beyond underline.</strong>
              </p>

              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <p><a href="javascript:void(0);" class="text-primary">Primary link</a></p>
                  <p><a href="javascript:void(0);" class="text-secondary">Secondary link</a></p>
                  <p><a href="javascript:void(0);" class="text-success">Success link</a></p>
                  <p><a href="javascript:void(0);" class="text-danger">Danger link</a></p>
                  <p><a href="javascript:void(0);" class="text-warning">Warning link</a></p>
                  <p><a href="javascript:void(0);" class="text-info">Info link</a></p>
                  <p><a href="javascript:void(0);" class="text-light bg-dark">Light link</a></p>
                  <p><a href="javascript:void(0);" class="text-dark">Dark link</a></p>
                  <p><a href="javascript:void(0);" class="text-muted">Muted link</a></p>
                  <p><a href="javascript:void(0);" class="text-white bg-dark">White link</a></p>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-primary&quot;&gt;Primary link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-secondary&quot;&gt;Secondary link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-success&quot;&gt;Success link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-danger&quot;&gt;Danger link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-warning&quot;&gt;Warning link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-info&quot;&gt;Info link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-light bg-dark&quot;&gt;Light link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-dark&quot;&gt;Dark link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-muted&quot;&gt;Muted link&lt;/a&gt;&lt;/p&gt;
  &lt;p&gt;&lt;a href=&quot;javascript:void(0);&quot; class=&quot;text-white bg-dark&quot;&gt;White link&lt;/a&gt;&lt;/p&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Background color</h5>
              <p>Similar to the contextual text color classes, easily set the background of an element to any contextual
                class. Anchor components will darken on hover, just like the text classes. Background utilities
                <strong>do
                  not set <code class="text-danger">color</code></strong>, so in some cases you’ll want to use <code
                  class="text-danger">.text-*</code> utilities.
              </p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="p-3 mb-2 bg-primary text-white">.bg-primary</div>
                  <div class="p-3 mb-2 bg-secondary text-white">.bg-secondary</div>
                  <div class="p-3 mb-2 bg-success text-white">.bg-success</div>
                  <div class="p-3 mb-2 bg-danger text-white">.bg-danger</div>
                  <div class="p-3 mb-2 bg-warning text-dark">.bg-warning</div>
                  <div class="p-3 mb-2 bg-info text-white">.bg-info</div>
                  <div class="p-3 mb-2 bg-light text-dark text-dark">.bg-light text-dark</div>
                  <div class="p-3 mb-2 bg-dark text-white">.bg-dark</div>
                  <div class="p-3 mb-2 bg-white text-dark">.bg-white</div>
                  <div class="p-3 mb-2 bg-transparent text-dark">.bg-transparent</div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;p-3 mb-2 bg-primary text-white&quot;&gt;.bg-primary&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-secondary text-white&quot;&gt;.bg-secondary&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-success text-white&quot;&gt;.bg-success&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-danger text-white&quot;&gt;.bg-danger&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-warning text-dark&quot;&gt;.bg-warning&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-info text-white&quot;&gt;.bg-info&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-light text-dark text-dark&quot;&gt;.bg-light text-dark&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-dark text-white&quot;&gt;.bg-dark&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-white text-dark&quot;&gt;.bg-white&lt;/div&gt;
  &lt;div class=&quot;p-3 mb-2 bg-transparent text-dark&quot;&gt;.bg-transparent&lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Background gradient</h5>

              <p>When <code class="text-danger">$enable-gradients</code> is set to <code class="text-danger">true</code>
                (default is <code class="text-danger">false</code>), you can use <code
                  class="text-danger">.bg-gradient-</code> utility classes. <a
                  href="https://getbootstrap.com/docs/4.5/getting-started/theming/javascript:void(0);sass-options">Learn
                  about our Sass
                  options</a> to enable these classes and more.</p>

            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
